import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// https://www.leadtools.com/help/sdk/v21/dh/to/web-scanning-framework.html

interface TwainSource {
  value: string;
  viewValue: string;
}

@Component({
  standalone: false,
  selector: 'app-select-source-dlg',
  templateUrl: './select-source-dlg.component.html',
  styleUrls: ['./select-source-dlg.component.scss']
})

export class SelectSourceDlgComponent implements OnInit {
  private scanningService: lt.Scanning.IScanningSession;

  message = '';
  isConfirmDisabled = true;
  selectedTwain = '';
  twainsources: string[];
  dlgStatus: any;
  isLoading = true;
  isErrorFindingTwainDrivers = false;

  constructor(
    public dialogRef: MatDialogRef<SelectSourceDlgComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.isLoading = true;
    this.message = this.data.message;

    let storedTwainString = localStorage.getItem('IMAGE_ACQUIRE_TWAIN');
    console.log('storedTwainString ' + storedTwainString);
    console.log('selectedTwain ' + this.selectedTwain);
    
    // Load existing TWAIN source from localStorage if available and valid
    if (storedTwainString && 
        storedTwainString !== 'undefined' && 
        storedTwainString !== 'null' && 
        storedTwainString.trim() !== '') {
      try {
        this.selectedTwain = JSON.parse(storedTwainString);
      } catch (error) {
        console.error('Error parsing stored TWAIN source:', error);
        // If parsing fails, clear the invalid value
        localStorage.removeItem('IMAGE_ACQUIRE_TWAIN');
      }
    }
    // If no valid stored value, selectedTwain will remain empty
    // and will be set from status.selectedSource when getStatus() succeeds (line 67)

    setTimeout(() => {
      if (!this.twainsources || this.twainsources.length === 0) {
        // this.isErrorFindingTwainDrivers = true;
        this.isLoading = false;
      }
    }, 10000);

    this.scanningService = lt.Scanning.ScanningFactory.createSession('http://localhost:18080/TDOxServiceBroker/');
    this.scanningService.start(null).done(() => {
      console.log('scanning service started');
      this.scanningService.getStatus()
        .done((status) => {
          // Scanning service - getStatus succeed
          if (!this.selectedTwain) {
            this.selectedTwain = status.selectedSource;
          }
          this.selectSource();
          this.scanningService.getSources()
            .done((sources) => {
              const scanSource = status.selectedSource;
              this.twainsources = sources;
              // Scanning service - getSources succeed
              let options = '';
              for (const item of sources) {
                if (item === scanSource) {
                  options += '<option selected=\'selected\'>' + item + '</option>';
                }
                else {
                  options += '<option>' + item + '</option>';
                }
              }

              console.log('twain sources ' + options);
              this.isLoading = false;
            })
            .fail((ee) => {
              // Scanning service - getSources failed
              // this._errorDlg.show();
              console.log(ee);
            });
        })
        .fail(() => {
          // Scanning service - getStatus failed
          this.scanningService.start(null)
            .done(() => {
              // this.onSelectSource();
            });
        });
    }).fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
      this.isErrorFindingTwainDrivers = true;
      console.log('No Twain Drivers installed.');
    });
  }

  confirm() {
    console.log('selectedTwain ' + this.selectedTwain);
    this.selectSource();
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }

  selectSource() {
    this.scanningService.selectSource(this.selectedTwain)
      .done(() => {
        console.log('done selectSource');

        this.scanningService.getStatus()
          .done((status) => {
            // Scanning service - getStatus succeed
            this.selectedTwain = status.selectedSource;
            this.isConfirmDisabled = false;
            console.log('in confirm -select- status.selectedSource ' + status.selectedSource);
            localStorage.setItem('IMAGE_ACQUIRE_TWAIN', JSON.stringify(status.selectedSource));
          })
          .fail(() => {
            // Scanning service - getStatus failed
            this.scanningService.start(null)
              .done(() => {
                // this.onSelectSource();
              });
          });
      }).fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
    })
      .fail((jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
      });
  }
}
